// extracted by mini-css-extract-plugin
module.exports = {"select":"PagePhotoAlbumBlock_select__417_W","selectWrap":"PagePhotoAlbumBlock_selectWrap__h7UpB","photoListWarp":"PagePhotoAlbumBlock_photoListWarp__Sa99j"};